import _extends from "@babel/runtime-corejs3/helpers/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime-corejs3/helpers/objectWithoutPropertiesLoose";
import React from 'react';
import Input from "../../core/input";
import TextArea from "../../core/textarea";
import RichText from "../rich-text";
/**
 * wrapper component for the Input/TextArea/RichText components, based on isRichEditor, isMultiline
 */

export var TextEditor = function TextEditor(_ref) {
  var isRichEditor = _ref.isRichEditor,
      isMultiline = _ref.isMultiline,
      useMentions = _ref.useMentions,
      mentionList = _ref.mentionList,
      toolbarOptions = _ref.toolbarOptions,
      rest = _objectWithoutPropertiesLoose(_ref, ["isRichEditor", "isMultiline", "useMentions", "mentionList", "toolbarOptions"]);

  return isRichEditor ? /*#__PURE__*/React.createElement(RichText, _extends({
    isMultiline: isMultiline,
    useMentions: useMentions,
    mentionList: mentionList,
    toolbarOptions: toolbarOptions
  }, rest, {
    style: {
      marginBottom: 0
    }
  })) : isMultiline ? /*#__PURE__*/React.createElement(TextArea, rest) : /*#__PURE__*/React.createElement(Input, rest);
};
export default TextEditor;
//# sourceMappingURL=index.js.map